import type { ContainerType } from "~/container";
import type { IApi } from "~/interfaces/IApi";
import type { ISharedUrlService } from "@saif-reporting/domain/interfaces/services/ISharedUrlService.js";
import type { SharedUrlDto } from "@saif-reporting/domain/dtos/models/SharedUrlDto.js";
import type { Paginated } from "@saif-reporting/domain/dtos/Paginated.js";
import type { SharedUrlQuery } from "@saif-reporting/domain/dtos/sharedUrlDtos.js";

export class SharedUrlService implements ISharedUrlService {
  private readonly baseApi: IApi;

  constructor({ baseApi }: ContainerType) {
    this.baseApi = baseApi;
  }

  async getAllForUser(query: SharedUrlQuery): Promise<Paginated<SharedUrlDto>> {
    return await this.baseApi.$fetch<Paginated<SharedUrlDto>>("/shared-urls", {
      query,
    });
  }

  async delete(id: string): Promise<SharedUrlDto> {
    return await this.baseApi.$fetch<SharedUrlDto>(`/shared-urls/${id}`, {
      method: "delete",
    });
  }
}
